import {imageUrls} from 'Shared'

export class TestModeSettings {
    static testModeColor(isTestMode)    { return isTestMode ? '#006325' : '#00549E'; }
    static testModeName(isTestMode)     { return isTestMode ? 'Testmodus' : 'Übungsmodus'; }
    static testModeFgColor(isTestMode)  { return isTestMode ? 'testFgColor' : 'exerciseFgColor' }
    static testModeBgColor(isTestMode)  { return isTestMode ? 'testColor' : 'exerciseColor' }
    static testModeIcon(isTestMode)
    {
        return isTestMode ? imageUrls.navIcons.testIconGreen
                          : imageUrls.navIcons.exerciseIcon
    }
    static testClockIcon(isTestMode) {
        return isTestMode  ? imageUrls.icons.clockIconGreen
                           : imageUrls.icons.clockIcon
    }
}

export default TestModeSettings;